import React from "react";
import { cn } from "./cn";

/**
 * Bun selectable chip. Spec: components/core/Chip. For tile pickers
 * (pick-up-to-N in the welcome flow) and choice rows. Selected = 1.5px blue
 * border + blue tint; dashed = adder tile ("+ Child"); disabled = dimmed at
 * the pick cap. Distinct from FilterPill (whose active state is ink).
 */
export default function Chip({ type = 'button', selected, dashed, disabled, onClick, className, children, ...props }) {
  const classes = cn(
        "inline-flex min-h-11 sm:min-h-0 max-w-full items-center gap-[6px] font-instrument text-bun-body font-strong text-left whitespace-normal",
        "rounded-full px-[14px] py-[7px] cursor-pointer",
        "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bun-blue peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-bun-blue",
        dashed
          ? "border-[1.5px] border-dashed border-bun-line-strong bg-transparent text-bun-slate hover:bg-bun-mist"
          : selected
            ? "border-[1.5px] border-bun-blue bg-bun-tint-blue text-bun-blue-hover"
            : "border-[1.5px] border-bun-line bg-bun-surface text-bun-slate hover:bg-bun-mist",
        disabled && "opacity-45 cursor-default hover:bg-transparent",
        className
      );
  if (type === 'radio') {
    return <label className="inline-flex max-w-full">
      <input {...props} type="radio" checked={!!selected} disabled={disabled} className="peer sr-only" />
      <span className={cn(classes, 'w-full')}>{children}</span>
    </label>;
  }
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={dashed ? undefined : !!selected}
      {...props}
      className={classes}
    >
      {children}
    </button>
  );
}
